import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThumbsUp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="thumbs-up, thumb, hand, yes, pro"><path d="M6.75 10.75H2.75V20.25H6.75M6.75 20.25V11L11 2.75H11.6156C12.843 2.75 13.7808 3.84535 13.5917 5.0581L13.0161 8.75H18.2589C20.0956 8.75 21.5011 10.3856 21.2248 12.2013L20.3878 17.7013C20.1648 19.167 18.9046 20.25 17.422 20.25H6.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconThumbsUp;
